/*
Notes:产品详情ajax Api
Date:2018/8/31 by zenglihuai
*/

import ajax from './ajax'; //引用二次封装ajax.js
export default {
    getDetails:function(params){
        return ajax.postForm('loanform/base/loanBaseProduct/getLoanProductDetail.ht',params);
    },


};



// WEBPACK FOOTER //
// ./src/api/details.js